import * as React from 'react';
export var Search = function () {
    return React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-hidden": "true" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.936 5.936a6.611 6.611 0 0 0 8.322 10.192l3.413 3.413c.57.571 1.453.616 1.969.1.516-.517.472-1.399-.1-1.97l-3.412-3.413A6.611 6.611 0 0 0 5.937 5.937m1.87 7.48a3.967 3.967 0 1 1 5.61-5.61 3.967 3.967 0 0 1-5.61 5.61", fill: "currentColor" }));
};
